export default __webpack_public_path__ + "static/media/SG-Green-0002.02663aa8.png";